import React, { useState, useEffect } from "react";
import BarHorizontalGraph from "../BarHorizontalGraph/BarHorizontalGraph";
import ImageRatingGraph from "../ImageRatingGraph/ImageRatingGraph";
import PieGraph from "../PieGraph/PieGraph";
import staron from "../../../assets/staron.png";
import staroff from "../../../assets/staroff.png";
import hearton from "../../../assets/hearton.png";
import heartoff from "../../../assets/heartoff.png";
import radionbuttonon from "../../../assets/radionbuttonon.png";
import radionbuttonoff from "../../../assets/radionbuttonoff.png";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@material-ui/icons/ThumbDownAltOutlined";
//FACE 5
import SentimentVerySatisfiedTwoToneIcon from "@material-ui/icons/SentimentVerySatisfiedTwoTone";
//FACE 4
import EmojiEmotionsTwoToneIcon from "@material-ui/icons/EmojiEmotionsTwoTone";
//FACE 3
import SentimentSatisfiedTwoToneIcon from "@material-ui/icons/SentimentSatisfiedTwoTone";
//FACE 2
import MoodBadTwoToneIcon from "@material-ui/icons/MoodBadTwoTone";
//FACE 1
import SentimentVeryDissatisfiedTwoToneIcon from "@material-ui/icons/SentimentVeryDissatisfiedTwoTone";
import {
  Content,
  ContentTitle,
  ContentChoice,
  ContentImage,
  ContentTitleImage,
  ContentChoiceImage,
  ContentOpenText,
  ContentOpenTextTitle,
  ButtonDownLoad,
} from "./GraphicsResume.styled";
import { getFile } from "../../../services/FileManager";
import { theme as themeConfig } from "../../../themes/themes";

const GraphicsResume = ({ dataQuestions, fnDownLoad }) => {
  let [imagesChoice, setImagesChoice] = useState([]);
  let [sigleImageSend] = useState([]);

  const renderGrap = (q) => {
    let configuration = JSON.parse(q.jsonConfiguration);
    let data = [];
    let dto = {};
    let dataLabels = [];
    switch (configuration.typeQuestion) {
      case "MultipleChoiceSingleSelect":
        configuration.answerList.map((opt) => {
          let position = q.answerOptions.findIndex(
            (f) => f.optionAnswer == opt
          );
          data.push({
            value: position > -1 ? q.answerOptions[position].totalAnswers : 0,
            name: opt,
          });
        });
        dto = {
          title: q.questionName,
          subtitle: `${q.totalAnswers} responses`,
          data: data,
          formaterLegent: function (name) {
            let pos = q.answerOptions.findIndex((f) => f.optionAnswer == name);
            if (pos > -1)
              return `${name} | ${q.answerOptions[pos].totalAnswers}-${q.answerOptions[pos].percentage}%`;
            else return `${name} | 0-0%`;
          },
        };
        return <PieGraph option={dto}></PieGraph>;
      case "MultipleChoiceMultiSelect":
        configuration.answerList.map((opt) => {
          let position = q.answerOptions.findIndex(
            (f) => f.optionAnswer === opt
          );
          dataLabels.push(opt);
          data.push(position > -1 ? q.answerOptions[position].totalAnswers : 0);
        });
        dto = {
          title: q.questionName,
          subtitle: `${q.totalAnswers} responses`,
          dataLabels: dataLabels,
          data: data,
          formaterLegent: (params) => {
            let pos = q.answerOptions.findIndex(
              (f) => f.optionAnswer == params.name
            );
            return pos > -1 ? q.answerOptions[pos].percentage + "%" : "0%";
          },
        };
        return <BarHorizontalGraph option={dto}></BarHorizontalGraph>;
      case "QuestionYesNo":
        configuration.questionSettings.forEach((opt) => {
          let position = q.answerOptions.findIndex(
            (f) => f.optionAnswer === opt.value
          );
          data.push({
            value: position > -1 ? q.answerOptions[position].totalAnswers : 0,
            name: opt.value,
          });
        });
        dto = {
          title: q.questionName,
          subtitle: `${q.totalAnswers} responses`,
          data: data,
          formaterLegent: function (name) {
            let pos = q.answerOptions.findIndex((f) => f.optionAnswer == name);
            if (pos > -1)
              return `${name} | ${q.answerOptions[pos].totalAnswers}-${q.answerOptions[pos].percentage}%`;
            else return `${name} | 0-0%`;
          },
        };
        return <PieGraph doughnut={true} option={dto}></PieGraph>;
      case "ImageRating":
        q.answerOptions
          .slice()
          .sort((a, b) => parseInt(a.totalAnswers) - parseInt(b.totalAnswers))
          .forEach((q) => {
            data.push(q.totalAnswers);
            dataLabels.push(q.optionAnswer);
          });
        let symbol =
          configuration?.nameShape === "heart" ? hearton : radionbuttonon;
        let symbolLimit =
          configuration?.nameShape === "heart" ? heartoff : radionbuttonoff;
        dto = {
          title: q.questionName,
          subtitle: `${q.totalAnswers} responses - limit ${configuration?.cantElements
            } ${configuration?.nameShape == "numbers"
              ? configuration?.nameShape
              : configuration?.nameShape + "s"
            }`,
          labels: data,
          data: dataLabels,
          limit: configuration.cantElements,
          symbol: `image://${configuration?.nameShape === "star" ? staron : symbol
            }`,
          symbolLimit: `image://${configuration?.nameShape === "star" ? staroff : symbolLimit
            }`,
          formaterLegent: function (params) {
            let pos = q.answerOptions.findIndex(
              (f) => f.optionAnswer === params.value
            );
            return q.answerOptions[pos].percentage + "%";
          },
        };
        return <ImageRatingGraph option={dto}></ImageRatingGraph>;
      case "QuestionLike":
        return (
          <Content question={"like"}>
            <ContentTitle question={"like"}>
              <label>{q.questionName}</label>
              <br />
              <label>{`${q.totalAnswers} responses`}</label>
            </ContentTitle>
            {configuration.questionSettings.map((opt, i) => {
              let pos = q.answerOptions.findIndex(
                (f) => f.optionAnswer === opt.value
              );
              return (
                <ContentChoice question={"like"}>
                  {opt.value === "thumbUp" && (
                    <ThumbUpAltOutlinedIcon
                      style={{ fontSize: "10em", color: themeConfig.neutral.gray[2500] }}
                    ></ThumbUpAltOutlinedIcon>
                  )}
                  {opt.value === "thumbDown" && (
                    <ThumbDownAltOutlinedIcon
                      style={{ fontSize: "10em", color: themeConfig.neutral.gray[2500] }}
                    ></ThumbDownAltOutlinedIcon>
                  )}
                  <span>
                    {pos > -1 ? q.answerOptions[pos].totalAnswers : 0} -{" "}
                    {pos > -1 ? q.answerOptions[pos].percentage : 0}%
                  </span>
                </ContentChoice>
              );
            })}
          </Content>
        );
      case "SmileyFaces":
        return (
          <Content question={"smiley"} cant={configuration.caritas.length}>
            <ContentTitle question={"smiley"}>
              <label
                style={{
                  fontSize: "17px",
                  fontWeight: "800",
                  color: " #4f4f4f",
                }}
              >
                {q.questionName}
              </label>
              <br />
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "800",
                  color: " #70727b",
                }}
              >{`${q.totalAnswers} responses`}</label>
            </ContentTitle>
            {configuration.caritas
              .sort((a, b) => a.id - b.id)
              .map((opt, i) => {
                let pos = q.answerOptions.findIndex(
                  (f) => f.optionAnswer == opt.value
                );
                return (
                  <ContentChoice question={"smiley"}>
                    <span>{opt.lbtext}</span>
                    {opt.value == "1" && (
                      <SentimentVerySatisfiedTwoToneIcon
                        style={{ fontSize: "7em", color: opt.color }}
                      ></SentimentVerySatisfiedTwoToneIcon>
                    )}
                    {opt.value == "2" && (
                      <EmojiEmotionsTwoToneIcon
                        style={{ fontSize: "7em", color: opt.color }}
                      ></EmojiEmotionsTwoToneIcon>
                    )}
                    {opt.value == "3" && (
                      <SentimentSatisfiedTwoToneIcon
                        style={{ fontSize: "7em", color: opt.color }}
                      ></SentimentSatisfiedTwoToneIcon>
                    )}
                    {opt.value == "4" && (
                      <MoodBadTwoToneIcon
                        style={{ fontSize: "7em", color: opt.color }}
                      ></MoodBadTwoToneIcon>
                    )}
                    {opt.value == "5" && (
                      <SentimentVeryDissatisfiedTwoToneIcon
                        style={{ fontSize: "7em", color: opt.color }}
                      ></SentimentVeryDissatisfiedTwoToneIcon>
                    )}
                    <span>
                      {pos > -1 ? q.answerOptions[pos].totalAnswers : 0} -{" "}
                      {pos > -1 ? q.answerOptions[pos].percentage : 0}%
                    </span>
                  </ContentChoice>
                );
              })}
          </Content>
        );
      case "MultipleChoiceImageSingleSelect":
        let cant = imagesChoice.filter(
          (f) => f.questionName === q.questionName
        );
        return (
          <div style={{ display: "flex" }}>
            <ContentImage cant={cant.length}>
              <ContentTitleImage>
                <label
                  style={{
                    fontSize: "17px",
                    fontWeight: "800",
                    color: " #4f4f4f",
                  }}
                >
                  {q.questionName}
                </label>
                <br />
                <label
                  style={{
                    fontSize: "14px",
                    fontWeight: "800",
                    color: " #70727b",
                  }}
                >{`${q.totalAnswers} responses`}</label>
              </ContentTitleImage>
              {imagesChoice.map((obj, i) => {
                if (obj.questionName === q.questionName) {
                  return (
                    <ContentChoiceImage key={i}>
                      <span>{obj.lblTxt}</span>
                      <img src={obj.url} alt="" />
                      <span>
                        {obj.totalAnswers} - {obj.percentage}%
                      </span>
                    </ContentChoiceImage>
                  );
                }
                return null;
              })}
            </ContentImage>
          </div>
        );
      case "OpenText":
        return (
          <ContentOpenText question={"like"}>
            <ContentOpenTextTitle question={"like"}>
              <label>{q.questionName}</label>
              <br />
              <label>{`${q.totalAnswers} responses`}</label>
            </ContentOpenTextTitle>
            <div style={{ textAlign: "center" }}>
              <ButtonDownLoad
                onClick={() => fnDownLoad(q.questionBankId, q.questionName)}
              >
                Download details
              </ButtonDownLoad>
            </div>
          </ContentOpenText>
        );
      default:
        break;
    }
  };

  useEffect(() => {
    if (dataQuestions && dataQuestions.length) {
      dataQuestions.forEach((question) => {
        let configuration = JSON.parse(question.jsonConfiguration);
        if (configuration.typeQuestion === "MultipleChoiceImageSingleSelect") {
          let objImg = sigleImageSend.find((x) => x === question.questionName);
          if (!objImg) {
            sigleImageSend.push(question.questionName);
            configuration.answerList.forEach((element) => {
              getFile(element.image).then((response) => {
                if (response && response.type !== "archivo-noexistente/json") {
                  let arrayimg = [];
                  let pos = question.answerOptions.findIndex((f) => {
                    arrayimg = f.optionAnswer.split("|");

                    return arrayimg[1] === element.image;
                  });

                  let obj = {
                    questionName: question.questionName,
                    percentage:
                      pos > -1 ? question.answerOptions[pos].percentage : 0,
                    totalAnswers:
                      pos > -1 ? question.answerOptions[pos].totalAnswers : 0,
                    lblTxt: element.text,
                    nameImage: element.image,
                    url: URL.createObjectURL(response),
                  };
                  imagesChoice.push(obj);
                  setImagesChoice([...imagesChoice]);
                }
              });
            });
          }
        }
      });
    }

    return () => {
      setImagesChoice([]);
      sigleImageSend = [];
    };
  }, [dataQuestions]);

  return (
    <div className="ContentGraphics" style={{ display: "grid" }}>
      {dataQuestions.map((q, i) => {
        return <div key={i}>{renderGrap(q)}</div>;
      })}
    </div>
  );
};

export default GraphicsResume;
